<script setup lang="ts">
import { HomeButton } from '@/components/home'
import PuzzleChallengeIcon from '@/assets/images/puzzle-challenge-icon.webp'
import PuzzleStar from '@/assets/images/carousel-banners/puzzle-challenge-button-star.webp'
import { usePuzzleChallenge } from '@/composables/game/challenges'
import { twMerge } from 'tailwind-merge'

withDefaults(defineProps<{
  containerClass?: string
}>(), {
  containerClass: '',
})

const { isPuzzleChallengeLive, countdown } = usePuzzleChallenge()
</script>

<template>
  <HomeButton
    v-if="isPuzzleChallengeLive"
    label="Challenge"
    :countdown="{ value: countdown, dangerThreshold: 3600 * 3 }"
    :button-class="twMerge('bg-[linear-gradient(138deg,#EE1F41_8.33%,#5A7E9F_47.19%)] p-0.5', containerClass)"
  >
    <img
      class="size-[80px] absolute object-cover -bottom-5"
      :src="PuzzleChallengeIcon"
      alt="Puzzle Challenge Icon"
    >
    <template #overlay>
      <img
        class="absolute left-3 h-[25%] z-[2] top-0"
        :src="PuzzleStar"
      >
      <img
        class="absolute left-0.5 h-[25%] z-[2] top-3 rotate-[45deg]"
        :src="PuzzleStar"
      >
    </template>
  </HomeButton>
</template>
